module.exports = __webpack_public_path__ + "img/4.e570b65a.jpg";